export enum PageChangeDirectionEnum {
    INCREMENT=1,
    DECREMENT=-1
}
